import { COHORT_NAME, } from "./constant";
import { COHORT_TYPE } from "./constant";
import { COHORT_AREANAME } from "./constant";
import { SELECT_USER } from "./constant";
import { SELECT_VM } from "./constant";

export function onChange_CohortName() {
  console.log("cohort name",)
  return {
    type: COHORT_NAME,
   
  };
}

export function onChange_CohortType() {
  console.log("cohort type ",)
  return {
    type: COHORT_TYPE,
    
  };
}

export function onChange_CohortAreaName() {
  console.log("cohort area name")
  return {
    type: COHORT_AREANAME,
    
  };
}

export function onChange_CohortSelectUser(selectedUsers) {
  console.log("cohort select user", selectedUsers);
  return {
    type: SELECT_USER,
    payload: selectedUsers, // Include the payload here
  };
}




export function onChange_CohortSelectVM() {
  console.log("cohort select vm",)
  return {
    type: SELECT_VM,
    
  };
  
}


